import { render, staticRenderFns } from "./etarPage.vue?vue&type=template&id=1c87b16c"
import script from "./etarPage.vue?vue&type=script&lang=js"
export * from "./etarPage.vue?vue&type=script&lang=js"
import style0 from "./etarPage.vue?vue&type=style&index=0&id=1c87b16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports